<template>
    <BaseModal :class-name="'ConfigurationModal'"
               :title="'CONFIGURATION__CONFIGURATION'"
               @save="save"
               @close="close">

        <!--SIGN OUT-->
        <div class="ConfigurationModal__signout-container">
            <BaseButtonFlat :label="'CONFIGURATION__SIGN_OUT'"
                            :class-name="'ConfigurationModal__signout'"
                            @click="confirmSignout()" />
        </div>

        <!--TIMEZONE-->
        <BaseDropdown :label="'CONFIGURATION__TIMEZONE'"
                      :value="timezone"
                      :items="timezones"
                      :errors="errors['timezone']"
                      @change="setTimezone($event.target.value)" />

        <!--CULTURE-->
        <BaseLabel :text="'CONFIGURATION__LANGUAGE'" />
        <BaseSegmented :value="culture"
                       :items="cultures"
                       @change="setCulture" />
    </BaseModal>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import BaseModal from '../common/BaseModal.vue';
    import BaseLabel from '../common/BaseLabel.vue';
    import BaseSegmented from '../common/BaseSegmented.vue';
    import BaseDropdown from '../common/BaseDropdown.vue';
    import BaseButtonFlat from '../common/BaseButtonFlat.vue';
    import constants from '../../store/constants';

    export default {
        name: 'ConfigurationModal',
        components: {
            BaseModal,
            BaseLabel,
            BaseSegmented,
            BaseDropdown,
            BaseButtonFlat
        },
        computed: {
            ...mapState({
                timezone: s => s.configuration.timezone,
                culture: s => s.configuration.culture,
                errors: s => s.configuration.errors
            }),
            timezones: () => constants.timezones,
            cultures: () => constants.cultures
        },
        methods: {
            ...mapActions({
                close: 'configuration/close',
                save: 'configuration/save',
                confirmSignout: 'configuration/confirmSignout',
                setCulture: 'configuration/setCulture',
                setTimezone: 'configuration/setTimezone'
            })
        }
    };
</script>

<style>
    .BaseModal.ConfigurationModal {
        width: 400px;
    }

    .ConfigurationModal__signout-container{
        display:flex;
        justify-content:flex-end;
    }

    .BaseButtonFlat.ConfigurationModal__signout {
        color: #e64a19;
    }
</style>



// WEBPACK FOOTER //
// ConfigurationModal.vue?5bbc9b68